import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import classes from "./GetCustomerAndExpenditureReport.module.css";
import PermissionContext from "../../Store/permission-context";
import axios from "axios";
import GetRegisteredCustomerRecord from "./GetRegisteredCustomerRecord";

import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Table,
  Tabs,
  Tab,
} from "react-bootstrap";
import { Divider } from "rsuite";
import ProcessingModal from "./Modals/ProcessingModal";
import MonthlyExpenditure from "./GetReportTabs/MonthlyExpenditure";

const GetCustomerAndExpenditureReport = () => {
  const PCtx = useContext(PermissionContext);

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
        <Tabs
          defaultActiveKey="Customers"
          id="uncontrolled-tab-example"
          className={`${classes.hide4printing} ${"mb-3"}`}
          style={{ border: "1px brown solid" }}
        >
          {/* <Tab
            eventKey="Expenses"
            title="Monthly Expenses"
            className={classes.margin4printing}
          >
            <MonthlyExpenditure />
          </Tab> */}
          <Tab
            eventKey="Customers"
            title="Customers Purchase Report"
            className={classes.margin4printing}
          >
            <GetRegisteredCustomerRecord />
          </Tab>
        </Tabs>
      </Col>
    </Row>
  );
};

export default GetCustomerAndExpenditureReport;
